document.addEventListener("DOMContentLoaded", function () {
    // copyEmail();
    fancyBoxPopups();
});

 


function fancyBoxPopups() {
    var onFancyboxReady = window.mobidevOnFancyboxReady || function (cb) {
        if ($.fn && $.fn.fancybox) {
            cb();
        }
    };

    onFancyboxReady(function () {
        $('div[data-fancybox]').fancybox({
            padding: 10
        });
    });
}

function copyEmail(){
    const emailCards = document.querySelectorAll(".contact-cards__card[data-email]");

    if (!emailCards.length) return ;

    emailCards.forEach(card => {
        const email = card.getAttribute("data-email");
        if (!email) return ;

        card.addEventListener("click", (event) => {
           
            const message = document.createElement("div");
            message.textContent = "Email copied!";
            message.style.position = "absolute";
            message.style.background = "#005650";
            message.style.color = "white";
            message.style.padding = "5px";
            message.style.borderRadius = "5px";
            message.style.zIndex = "1000";
            message.style.opacity = '0';
            message.style.transition = 'opacity 0.25s ease-in-out';
            message.style.pointerEvents = "none"; 
            document.body.appendChild(message);
            setTimeout(() => {
                message.style.opacity = '1';
                message.style.left = `${event.pageX + 10}px`; 
                message.style.top = `${event.pageY + 10}px`; 
            }, 50);
            
            const moveMessage = (e) => {
                message.style.left = `${e.pageX + 10}px`; 
                message.style.top = `${e.pageY + 10}px`;  
            };

            document.addEventListener("mousemove", moveMessage);
            if (navigator.clipboard) {
                navigator.clipboard.writeText(email);
               
            } else {
                const textarea = document.createElement("textarea");
                textarea.value = email;
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand("copy");
                document.body.removeChild(textarea);
            }
            setTimeout(() => {
                message.style.opacity = '0'
            }, 2750);
          
            setTimeout(() => {
                message.style.display = "none";
                document.removeEventListener("mousemove", moveMessage); 
            }, 3000);
        });
    });
}
